import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useSpearPartsApi() {
  const callApi = useApiCall();
 
  const getSpearPartsList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.GET_SPEAR_PARTS_LIST, data, onSuccess, onError);
  };
  const saveSpearParts = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.SAVE_SPEAR_PARTS, data, onSuccess, onError);
  };
  const deleteSpearParts = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.DELETE_SPEAR_PARTS, data, onSuccess, onError);
  };
  const getPartsAttachments = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_ATTACHMENTS, data, onSuccess, onError);
  };
  const savePartsAttachments = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.SAVE_PARTS_ATTACHMENTS, data, onSuccess, onError);
  };
  const deletePartsAttachments = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.DELETE_PARTS_ATTACHMENTS, data, onSuccess, onError);
  };

  const getPartsStatus = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_STATUS, data, onSuccess, onError);
  };
  const getSparePartsCategoryList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_CATEGORY_LIST, data, onSuccess, onError);
  }
  const getPartsUnitList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_UNIT_LIST, data, onSuccess, onError);
  }


  const exportToPdf = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.EXPORT_TO_PDF, data, onSuccess, onError);
  };
  const exportToXls = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.EXPORT_TO_XLS, data, onSuccess, onError);
  };
  const ExportQrCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.EXPORT_QR_CODE, data, onSuccess, onError);
  }

  const savePartsImage = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.SAVE_PARTS_IMAGE, data, onSuccess, onError);
  };

   
  const getSpearPartsCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.GET_SPEAR_PARTS_CODE, data, onSuccess, onError);
  };

  
  const GetPartsNotesList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.GET_PARTS_NOTES_LIST, data, onSuccess, onError);
  };
  const SavePartsNotes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.SAVE_PARTS_NOTES, data, onSuccess, onError);
  };

  
  const locationWiseStock = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.LOCATION_WISE_STOCK, data, onSuccess, onError);
  };
  const purchaseHistory = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.PURCHASE_HISTORY, data, onSuccess, onError);
  };
  const stockPickingHistory = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.STOCK_PICKING_HISTORY, data, onSuccess, onError);
  };
  const stockCycleCountHistory = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.STOCK_CYCLE_COUNT_HISTORY, data, onSuccess, onError);
  };
  const stockAdjustmentHistory = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.STOCK_ADJUSTMENT_HISTORY, data, onSuccess, onError);
  };

  const SavePartsVendorMap = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.SAVE_PARTS_VENDOR_MAP, data, onSuccess, onError);
  };

  const DeletePartsVendorMap = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.DELETE_PARTS_VENDOR_MAP, data, onSuccess, onError);
  }

  const getCurrentStockDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.GET_CURRENT_STOCK_DETAILS, data, onSuccess, onError);
  };

  const getPersonalStockReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.GET_PERSONAL_STOCK_REPORT, data, onSuccess, onError);
  };

  const exportReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SPEAR_PARTS.EXPORT_REPORT_TO_XLS, data, onSuccess, onError);
  };


  return { 
    getSpearPartsList,
    saveSpearParts,
    deleteSpearParts,
    getPartsAttachments,
    savePartsAttachments,
    deletePartsAttachments,
    getSpearPartsCode,
    savePartsImage,
    getPartsStatus,
    getSparePartsCategoryList,
    getPartsUnitList,

    exportToPdf, 
    exportToXls,
    ExportQrCode,

    GetPartsNotesList,
    SavePartsNotes,

    locationWiseStock,
    purchaseHistory,
    stockPickingHistory,
    stockCycleCountHistory,
    stockAdjustmentHistory,
    SavePartsVendorMap,
    DeletePartsVendorMap,
    getCurrentStockDetails,
    getPersonalStockReport,
    exportReportToXLS
  };
}
